import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import React from 'react';

type Props = {
    title: string;
    onClose: () => void;
};

const StyHeader = styled(Box, {
    name: 'StyHeader',
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export default function PanelDetailsHeader({
    title,
    onClose,
}: Props): React.ReactElement {
    return (
        <StyHeader>
            <Typography variant="h4">{title}</Typography>
            <IconButton aria-label="delete" onClick={onClose} size="large">
                <CloseIcon />
            </IconButton>
        </StyHeader>
    );
}
